import BankTransactionType from './bankTranscation.types';

/** ***************** GET BANK  TRANSACTION LIST START *********************** */
export const getBankTransactionListStart = (getData: any) => ({
	type: BankTransactionType.GET_BANK_TRANSACTION_LIST_START,
	payload: getData,
});

export const getBankTransactionListSuccess = (successData: any) => ({
	type: BankTransactionType.GET_BANK_TRANSACTION_LIST_SUCCESS,
	payload: successData,
});

export const getBankTransactionListFailure = (failureData: any) => ({
	type: BankTransactionType.GET_BANK_TRANSACTION_LIST_FAILURE,
	payload: failureData,
});

export const getBankTransactionListResponseResetStart = () => ({
	type: BankTransactionType.GET_BANK_TRANSACTION_LIST_RESPONSE_RESET,
});

export const getBankTransactionListResponseChanged = () => ({
	type: BankTransactionType.GET_BANK_TRANSACTION_LIST_RESPONSE_CHANGED,
});

/** ***************** GET BANK  TRANSACTION LIST END *********************** */

/** ***************** ADD BANK  TRANSACTION DETAILS START *********************** */
export const addBankTransactionDetailsStart = (addData: any) => ({
	type: BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_START,
	payload: addData,
});

export const addBankTransactionDetailsSuccess = (successData: any) => ({
	type: BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_SUCCESS,
	payload: successData,
});

export const addBankTransactionDetailsFailure = (failureData: any) => ({
	type: BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_FAILURE,
	payload: failureData,
});

export const addBankTransactionDetailsResponseResetStart = () => ({
	type: BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_RESPONSE_RESET,
});

export const addBankTransactionDetailsResponseChanged = () => ({
	type: BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD BANK  TRANSACTION DETAILS END *********************** */

/** ***************** UPDATE BANK  TRANSACTION DETAILS START *********************** */
export const updateBankTransactionDetailsStart = (updateData: any) => ({
	type: BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_START,
	payload: updateData,
});

export const updateBankTransactionDetailsSuccess = (successData: any) => ({
	type: BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_SUCCESS,
	payload: successData,
});

export const updateBankTransactionDetailsFailure = (failureData: any) => ({
	type: BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_FAILURE,
	payload: failureData,
});

export const updateBankTransactionDetailsResponseResetStart = () => ({
	type: BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_RESPONSE_RESET,
});

export const updateBankTransactionDetailsResponseChanged = () => ({
	type: BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE BANK  TRANSACTION DETAILS END *********************** */

/** ***************** DELETE BANK  TRANSACTION DETAILS START *********************** */
export const deleteBankTransactionDetailsStart = (deleteData: any) => ({
	type: BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_START,
	payload: deleteData,
});

export const deleteBankTransactionDetailsSuccess = (successData: any) => ({
	type: BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteBankTransactionDetailsFailure = (failureData: any) => ({
	type: BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteBankTransactionDetailsResponseResetStart = () => ({
	type: BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_RESPONSE_RESET,
});

export const deleteBankTransactionDetailsResponseChanged = () => ({
	type: BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE BANK  TRANSACTION DETAILS END *********************** */

/** ***************** FETCH BANK  TRANSACTION DETAILS START *********************** */
export const fetchBankTransactionDetailsStart = (fetchData: any) => ({
	type: BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_START,
	payload: fetchData,
});

export const fetchBankTransactionDetailsSuccess = (successData: any) => ({
	type: BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchBankTransactionDetailsFailure = (failureData: any) => ({
	type: BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchBankTransactionDetailsResponseResetStart = () => ({
	type: BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_RESPONSE_RESET,
});

export const fetchBankTransactionDetailsResponseChanged = () => ({
	type: BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH BANK  TRANSACTION DETAILS END *********************** */

/** ***************** BANK  TRANSACTION  EXCEL  PAGE DETAILS START *********************** */
export const fetchAllGroupOfficerExportReportStart = (addData: any) => ({
	type: BankTransactionType.BANK_TRANSACTION_EXCEL_START,
	payload: addData,
});

export const fetchAllGroupOfficerExportReportSuccess = (successData: any) => ({
	type: BankTransactionType.BANK_TRANSACTION_EXCEL_SUCCESS,
	payload: successData,
});

export const fetchAllGroupOfficerExportReportFailure = (failureData: any) => ({
	type: BankTransactionType.BANK_TRANSACTION_EXCEL_FAILURE,
	payload: failureData,
});

export const fetchAllGroupOfficerExportReportResponseReset = () => ({
	type: BankTransactionType.BANK_TRANSACTION_EXCEL_RESPONSE_RESET_START,
});

export const fetchAllGroupOfficerExportReportResponseResetChanged = () => ({
	type: BankTransactionType.BANK_TRANSACTION_EXCEL_RESPONSE_CHANGED,
});

/** *****************BANK  TRANSACTION  EXCEL  PAGE DETAILS END *********************** */

/** ***************** GET MODEL VALUES  START *********************** */
export const getModelValuesStart = (getData: any) => ({
	type: BankTransactionType.GET_VALUES_MODEL_START,
	payload: getData,
});

export const getModelValuesSuccess = (successData: any) => ({
	type: BankTransactionType.GET_VALUES_MODEL_SUCCESS,
	payload: successData,
});

export const getModelValuesFailure = (failureData: any) => ({
	type: BankTransactionType.GET_VALUES_MODEL_FAILURE,
	payload: failureData,
});

export const getModelValuesResponseResetStart = () => ({
	type: BankTransactionType.GET_VALUES_MODEL_RESPONSE_RESET,
});

export const getModelValuesResponseChanged = () => ({
	type: BankTransactionType.GET_VALUES_MODEL_RESPONSE_CHANGED,
});

/** *****************GET  MODEL VALUES  END *********************** */

/** *****************CHECK BRANCH EOD START *********************** */
export const checkBranchEODStart = (getData: any) => ({
	type: BankTransactionType.CHECK_BRANCH_EOD_START,
	payload: getData,
});

export const checkBranchEODSuccess = (successData: any) => ({
	type: BankTransactionType.CHECK_BRANCH_EOD_SUCCESS,
	payload: successData,
});

export const checkBranchEODFailure = (failureData: any) => ({
	type: BankTransactionType.CHECK_BRANCH_EOD_FAILURE,
	payload: failureData,
});

export const checkBranchEODResetStart = () => ({
	type: BankTransactionType.CHECK_BRANCH_EOD_RESPONSE_RESET,
});

export const checkBranchEODChanged = () => ({
	type: BankTransactionType.CHECK_BRANCH_EOD_RESPONSE_CHANGED,
});

/** *****************CHECK BRANCH EOD END *********************** */

/** *****************SELECTED TRANSACTION APPROVE START *********************** */
export const selectedTransactionApproveStart = (getData: any) => ({
	type: BankTransactionType.SELECTED_TRANSACTION_APPROVE_START,
	payload: getData,
});

export const selectedTransactionApproveSuccess = (successData: any) => ({
	type: BankTransactionType.SELECTED_TRANSACTION_APPROVE_SUCCESS,
	payload: successData,
});

export const selectedTransactionApproveFailure = (failureData: any) => ({
	type: BankTransactionType.SELECTED_TRANSACTION_APPROVE_FAILURE,
	payload: failureData,
});

export const selectedTransactionApproveResetStart = () => ({
	type: BankTransactionType.SELECTED_TRANSACTION_APPROVE_RESET,
});

export const selectedTransactionApproveChanged = () => ({
	type: BankTransactionType.SELECTED_TRANSACTION_APPROVE_CHANGED,
});

/** *****************SELECTED TRANSACTION APPROVE  END *********************** */
